module.exports = __webpack_public_path__ + "28002881c2a48251d88272e269b2ced1.woff2";